import { connect } from 'react-redux'
import React, { PureComponent } from 'react'
import Waiting, { ISkin } from '../../views/waiting/Waiting'
import { bindActionCreators, AnyAction, Dispatch } from 'redux'
import viewSelector from '../../redux/selectors/camp/viewSelector'
import viewTypes from '../../helpers/enums/views'
import appActions from '../../redux/actions/appActions'

import withTransition from '../../hoc/Transition'
import withResizer from '../../hoc/Resizer'
import withRendererFilter from '../../hoc/RendererFilter'
import { ICampPlayerData } from '../../helpers/data/campPlayer'
import { IStore } from '../../redux/reducers/index'

interface IWaitingProps {
	players: ICampPlayerData[]
	playerUID: string
	containerScale: number
	isTeacher: boolean
	gameStart: () => void
	skin: ISkin
	areAnimationsEnabled: boolean
	animationsToggleUpdate: (enabled: boolean) => void
}

class WaitingConnector extends PureComponent<IWaitingProps> {
	render() {
		return (
			<Waiting
				players={this.props.players}
				skin={this.props.skin}
				playerUID={this.props.playerUID}
				scale={this.props.containerScale}
				isTeacher={this.props.isTeacher}
				onStart={this.props.gameStart}
				areAnimationsEnabled={this.props.areAnimationsEnabled}
				onAnimationsToggle={this.props.animationsToggleUpdate}
			/>
		)
	}
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
	return bindActionCreators(
		{
			gameStart: appActions.gameStart,
			animationsToggleUpdate: appActions.animationsToggleUpdate,
		},
		dispatch
	)
}

const mapStateToProps = (state: IStore) => {
	return viewSelector(state)
}

export default withTransition(
	withResizer(
		connect(mapStateToProps, mapDispatchToProps)(withRendererFilter(WaitingConnector, viewTypes.CAMP)),
		1024,
		768
	)
)
